import { CameraAlt, QrCode } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Scanner } from "@yudiel/react-qr-scanner";
import { GetData } from "contexts/DataContext";
import { getFirstInArray, isObjectEmpty } from "data/functions";
import React from "react";

import { GetCInfo } from "contexts/CompanyContext";
// import { useAuth } from "react-oidc-context";
import FieldBlock from "./FieldBlock";

export function OrderQrField(props) {
  const [value, setValue] = React.useState(props?.findParams?.qrRaw || "");
  const [open, setOpen] = React.useState(false);

  function changeValues(val) {
    setValue(val);
    props?.setFindParams((e) => {
      return {
        ...e,
        code: val ? val : null,
      };
    });

    setOpen(false);
  }

  return (
    <React.Fragment>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "",
          justifyContent: "center",
          padding: "6px",
          width: "100%",
        }}
      > */}
      <FieldBlock
        disableUpperCase={true}
        // disabled={true}
        endIcon={
          <Button
            onClick={() => setOpen(true)}
            sx={{ padding: "0 18px" }}
            variant="text"
          >
            Сканировать
          </Button>
        }
        icon={<QrCode />}
        label="qr-raw"
        onBlurFunc={changeValues}
        // length={12}
        placeholder="QR-код"
        setValue={changeValues}
        title={"или отсканируйте QR-код документа/личного кабинета"}
        value={value}
      />
      <DialogScanner
        changeValues={changeValues}
        open={open}
        setOpen={setOpen}
      />
    </React.Fragment>
  );
}

function DialogScanner(props) {
  const [paused, setPaused] = React.useState(true);
  const { dataObj, forceSetDataObj } = GetData();
  const { cInfo } = GetCInfo();
  // const auth = useAuth();

  return (
    <React.Fragment>
      <Dialog
        onClose={() => props?.setOpen(false)}
        open={props?.open}
        // sx={{ zIndex: 1201 }}
      >
        <DialogTitle>Сканирование</DialogTitle>
        <DialogContent>
          {paused ? (
            <Box
              onClick={() => setPaused(false)}
              sx={{
                alignItems: "center",
                aspectRatio: 1,
                border: "1px dashed rgba(143, 143, 143, 0.245)",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                height: "200px",
                justifyContent: "center",
                position: "relative",
                // width: "100%",
              }}
            >
              <CameraAlt />
              <Typography sx={{ textAlign: "center", textWrap: "balance" }}>
                Отсканируйте QR-код документа или личного кабинета
              </Typography>
            </Box>
          ) : (
            <Scanner
              components={{
                audio: false,
                finder: true,
                torch: false,
                zoom: true,
              }}
              constraints={{
                advanced: [
                  {
                    autoGainControl: true,
                    // aspectRatio: {
                    //   max: 1,
                    //   min: 1,
                    // },
                    facingMode: {
                      exact:
                        dataObj?.cameraType !== "front"
                          ? "environment"
                          : "user",
                    },
                  },
                ],
              }}
              formats={[
                "aztec",
                "code_128",
                "code_39",
                "code_93",
                "codabar",
                "databar",
                "databar_expanded",
                "databar_limited",
                "data_matrix",
                "dx_film_edge",
                "ean_13",
                "ean_8",
                "itf",
                "maxi_code",
                "micro_qr_code",
                "pdf417",
                "qr_code",
                "rm_qr_code",
                "upc_a",
                "upc_e",
                "linear_codes",
                "matrix_codes",
                "unknown",
              ]}
              onError={(e) => {
                // setV(e?.message);
                setPaused(true);
              }}
              onScan={(e) => {
                let decodeRaw = getFirstInArray(e);
                if (!isObjectEmpty(decodeRaw) && decodeRaw?.rawValue !== "") {
                  props?.changeValues(decodeRaw?.rawValue, cInfo?.UUID);
                }

                setPaused(true);
              }}
              paused={paused}
              // scanDelay="400"
              styles={{
                container: {
                  aspectRatio: 1,
                  height: "auto",
                  maxWidth: "100%",
                  overflow: "hidden",
                  // overflow: "visible",
                },
                // finderBorder: 1,
                video: {
                  height: "100%",
                  // marginTop: "-40%",
                  // maxHeight: "200px",
                  maxWidth: "100%",
                },
                // svg: {
                //   width: "20px",
                // },
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props?.setOpen(false);
            }}
            variant="outlined"
          >
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
